export default __webpack_public_path__ + "static/media/alfalfa.307b2550.jpeg";